import Footer from 'components/footer'
import Header from 'components/header'
import React from 'react'

interface LayoutProps {
    children: React.ReactNode;
}
export default function Layout({ children }: LayoutProps) {
    return (
        <div className='min_height'>
            <div className="flex flex-col fullscreen" >
                <div className='flex h-20 '><Header /></div>
                <div className='flex flex-1 overflow-auto relative'>{children}</div>
                <div className='flex h-14'><Footer /></div>
            </div>

        </div>
    )
}
